import {call, put, takeLatest} from 'redux-saga/effects'
import {ParamsModel} from 'src/app/modules/common/Model'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {AbroadRepresentativeModel} from '../Model'
import {actions} from './action'
import {actionTypes} from './constants'
import {BulkAction, service} from './service'

const globalError = (err: any) => ({type: globalActionTypes.GLOBAL_ERROR, payload: err?.response?.data?.message})

function* getAbroadRepresentativeSaga(action: ActionModel) {
  try {
    const params = action.payload as unknown as ParamsModel
    const response: ResponseModel = yield call(service.getAbroadRepresentative, params)
    yield put(actions.getAbroadRepresentativeSuccess(response?.data?.data))
  } catch (err: any) {
    if (err.response) yield put(globalError(err))
  }
  yield put(actions.getAbroadRepresentativeFinish())
}

function* addAbroadRepresentativeSaga(action: ActionModel) {
  try {
    yield call(service.addAbroadRepresentative, action.payload as unknown as AbroadRepresentativeModel)
    yield put(actions.saveAbroadRepresentativeSuccess())
  } catch (err: any) {
    if (err.response) yield put(globalError(err))
  }
  yield put(actions.saveAbroadRepresentativeFinish())
}

function* updateAbroadRepresentativeSaga(action: ActionModel) {
  try {
    const {data, id} = action.payload as unknown as {data: AbroadRepresentativeModel; id: string}
    yield call(service.updateAbroadRepresentative, data, id)
    yield put(actions.saveAbroadRepresentativeSuccess())
  } catch (err: any) {
    if (err.response) yield put(globalError(err))
  }
  yield put(actions.saveAbroadRepresentativeFinish())
}

function* bulkAbroadRepresentativeSaga(action: ActionModel) {
  try {
    const {action: bulk, ids} = action.payload as unknown as {action: BulkAction; ids: string[]}
    yield call(service.bulkAbroadRepresentative, bulk, ids)
    yield put(actions.bulkAbroadRepresentativeSuccess(bulk))
  } catch (err: any) {
    if (err.response) yield put(globalError(err))
  }
  yield put(actions.bulkAbroadRepresentativeFinish())
}

export function* saga() {
  yield takeLatest(actionTypes.GET_ABROAD_REPRESENTATIVE_START, getAbroadRepresentativeSaga)
  yield takeLatest(actionTypes.ADD_ABROAD_REPRESENTATIVE_START, addAbroadRepresentativeSaga)
  yield takeLatest(actionTypes.UPDATE_ABROAD_REPRESENTATIVE_START, updateAbroadRepresentativeSaga)
  yield takeLatest(actionTypes.BULK_ABROAD_REPRESENTATIVE_START, bulkAbroadRepresentativeSaga)
}
